var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBathroom = function SvgBathroom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 14V15C21.75 16.91 20.68 18.57 19.1 19.41L19.75 22H17.75L17.25 20H8.25L7.75 22H5.75L6.4 19.41C5.59919 18.9852 4.92931 18.3501 4.46239 17.5731C3.99548 16.7961 3.74919 15.9065 3.75 15V14H2.75V12H20.75V5C20.75 4.73478 20.6446 4.48043 20.4571 4.29289C20.2696 4.10536 20.0152 4 19.75 4C19.25 4 18.87 4.34 18.75 4.79C19.38 5.33 19.75 6.13 19.75 7H13.75C13.75 6.20435 14.0661 5.44129 14.6287 4.87868C15.1913 4.31607 15.9544 4 16.75 4H16.92C17.33 2.84 18.44 2 19.75 2C20.5456 2 21.3087 2.31607 21.8713 2.87868C22.4339 3.44129 22.75 4.20435 22.75 5V14H21.75ZM19.75 14H5.75V15C5.75 15.7956 6.06607 16.5587 6.62868 17.1213C7.19129 17.6839 7.95435 18 8.75 18H16.75C17.5456 18 18.3087 17.6839 18.8713 17.1213C19.4339 16.5587 19.75 15.7956 19.75 15V14Z",
    fill: "#94A3B8"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBathroom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bathroom.63e43dd6.svg";
export { ForwardRef as ReactComponent };